import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { NAV, SITE } from "../../data/site";
import { Wordmark } from "./Brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-charcoal text-chalk">
    <div className="container-x py-20 md:py-28">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Wordmark h="h-20" />
          <p className="mt-8 max-w-sm text-chalk/60 font-light leading-relaxed text-sm">
            {SITE.positioning}
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="overline text-bronze mb-6 underline underline-offset-4 decoration-1">Studio</p>
          <ul className="space-y-3 text-sm text-chalk/70">
            <li>{SITE.location}</li>
            <li>
              <a href={`mailto:${SITE.email}`} className="link-underline" data-testid="footer-email">
                {SITE.email}
              </a>
            </li>
            <li>
              <a href={`tel:${SITE.phoneHref}`} aria-label={`Telephone Arc & Hollow on ${SITE.phone}`} className="link-underline whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-chalk rounded-sm" data-testid="footer-phone">
                {SITE.phone}
              </a>
            </li>
            <li>
              <a href={SITE.instagramUrl} target="_blank" rel="noreferrer noopener" aria-label="Visit Arc & Hollow on Instagram" className="inline-flex items-center gap-2 link-underline align-middle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-chalk rounded-sm" data-testid="footer-instagram">
                <Instagram size={16} strokeWidth={1.6} className="shrink-0" />
                <span>Instagram {SITE.instagram}</span>
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="overline text-bronze mb-6 underline underline-offset-4 decoration-1">Navigate</p>
          <ul className="space-y-3 text-sm text-chalk/70">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="link-underline">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="overline text-bronze mb-6 underline underline-offset-4 decoration-1">Legal</p>
          <ul className="space-y-3 text-sm text-chalk/70">
            <li><Link to="/privacy-policy" className="link-underline">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy" className="link-underline">Cookie Policy</Link></li>
            <li><Link to="/terms" className="link-underline">Website Terms</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-chalk/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-chalk/40 uppercase tracking-overline">
        <span>© {new Date().getFullYear()} Arc &amp; Hollow</span>
        <span>Interior architecture &amp; residential design, London</span>
      </div>
    </div>
  </footer>
);
